<template>
  <v-layout
    :class="[
      { disabled: disabled },
      // { 'module-selected': selected },
      { clickable: !isFull },
      { 'workshop-hover': !isFull && !disabled },
    ]"
    class="workshop-container"
    :style="{ backgroundColor: selected ? backgroundColor : '#f5f5f5' }"
    justify-space-between
    wrap
    :column="$vuetify.breakpoint.xsOnly"
    @click="selectWorkshop()"
  >
    <v-flex xs10 shrink>
      <v-layout>
        <v-flex v-hide="isFull" shrink>
          <v-icon
            slot="activator"
            :color="color"
            icon
            class="workshop-icon"
            :class="{ selected: selected }"
          >
            add_circle
          </v-icon>
        </v-flex>
        <v-flex shrink>
          <v-layout column>
            <v-flex class="workshop-title">
              <span :style="{ color: cardColor }">{{ name }}</span>
            </v-flex>
            <v-flex>
              <span>
                <span v-if="lecturerNames">{{ styles.heldBy || (eventId === '8265' ? 'Predavač: ' : 'Held by ') }}</span>
                <span v-if="lecturerNames" class="card-keyword" :style="{ color: cardColor }">{{
                  lecturerNames
                }}</span>
                <span v-if="eventId !== '4531' && eventId !== '8265'">{{ styles.on || ' on ' }}</span>
                <span
                  class="card-keyword"
                  :style="{ color: cardColor }"
                >{{ parseDate(from, eventId === '8265' ? 'DD/MM/YYYY' : 'dddd, Do MMMM') }}
                </span>
                <span>{{ (eventId === '4531' || eventId === '8265')? ' od ' : styles.from || ' from ' }}</span>
                <span class="card-keyword" :style="{ color: cardColor }">{{
                  parseDate(from, 'HH:mm')
                }}</span>
                <span>{{ (eventId === '4531' || eventId === '8265') ? ' do ' : styles.to || ' to ' }}</span>
                <span class="card-keyword" :style="{ color: cardColor }">{{
                  parseDate(to, 'HH:mm')
                }}</span>
              </span>
            </v-flex>
            <v-flex>
              <p
                class="workshop-description"
                :style="['952', '2444', '4531', '8265'].includes(eventId) && 'color: #454444;'"
              >
                {{ description }}
              </p>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex v-if="$vuetify.breakpoint.smAndUp" shrink align-self-center>
      <v-progress-circular
        v-if="!unlimitedAttendance"
        size="69"
        :rotate="-90"
        class="attendancy-color"
        :background-color="backgroundColor"
        :color="isFull || disabled ? '#333333' : color"
        :width="styles.hideCounter ? 0 : 5"
        :value="styles.hideCounter ? 0 : attendancePercentange"
      >
        <span v-if="isFull" class="full">{{ styles.full || (eventId === '8265' ? 'Popunjeno' : 'Full') }}</span>
        <span
          v-else-if="disabled && (eventId === '4531' || eventId === '8265')"
          class="overlap"
          style="color: red"
        >Preklapanje</span>
        <span v-else-if="disabled" class="overlap">{{ styles.overlap || 'Overlap' }}</span>
        <div v-else>
          <span v-if="!styles.hideCounter" class="attending">{{ getAttending() }}</span>
          <span v-if="!styles.hideCounter" class="limit">/{{ attendanceLimit }}</span>
          <v-icon class="check" :color="color">check_circle</v-icon>
        </div>
      </v-progress-circular>
      <div v-else style="position: relative">
        <v-icon class="check" color="his.r">check_circle</v-icon>
        <span v-if="disabled" class="overlap standalone-overlap">{{
          (eventId === '4531' || eventId === '8265') ? 'Preklapanje' : styles.overlap || 'Overlap'
        }}</span>
      </div>
    </v-flex>
    <v-flex v-else class="ml-32 attendancy-color">
      <span v-if="isFull" class="full">{{ eventId === '8265' ? 'Popunjeno' : 'Full' }}</span>
      <span v-else-if="disabled" class="overlap">{{
        (eventId === '4531' || eventId === '8265') ? 'Preklapanje' : styles.overlap || 'Overlap'
      }}</span>
      <div v-else-if="!unlimitedAttendance">
        <span class="attending">{{ getAttending() }}</span>
        <span class="limit">/{{ attendanceLimit }}</span>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import { getLecturerNames } from '../../utils'
export default {
  name: 'workshop-card',
  props: {
    workshop: {
      type: Object,
      default: null,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    styles: {
      type: Object,
      default: () => ({}),
    },
    eventId: {
      type: String,
      default: null,
    },
    color: {
      type: String,
      default: 'primary',
    },
    backgroundColor: {
      type: String,
      default: 'primary',
    },
  },
  data() {
    return {
      ...this.workshop,
      attendancePercentange: 0,
    }
  },
  computed: {
    isFull() {
      return this.attending >= this.attendanceLimit && !this.unlimitedAttendance
    },
    cardColor() {
      return this.isFull ? '#333333' : this.color
    },
    lecturerNames() {
      return getLecturerNames(this.lecturers)
    },
  },
  watch: {
    selected() {
      this.updatePercentange()
    },
    workshop(w) {
      this.attendanceLimit = w.attendanceLimit
      this.attending = w.attending
      this.description = w.description
      this.from = w.from
      this.id = w.id
      this.lecturers = getLecturerNames(w.lecturers)
      this.name = w.name
      this.to = w.to
      this.unlimitedAttendance = w.unlimitedAttendance
      this.updatePercentange()
    },
  },
  created() {
    setTimeout(this.updatePercentange, 500)
  },
  methods: {
    updatePercentange() {
      const attending = this.getAttending()
      this.attendancePercentange = (attending / this.attendanceLimit) * 100
    },

    selectWorkshop() {
      if (!this.isFull) {
        this.$emit('click')
      }
    },
    getAttending() {
      const value = this.selected ? 1 : 0

      return this.attending + value
    },
  },
}
</script>

<style scoped>
.workshop-title {
  font-family: Raleway, sans-serif;
  font-weight: bold;
  font-size: 18px;
  line-height: 1.33;
  margin-bottom: 8px;
}

.workshop-container {
  padding: 16px 32px 16px 16px;
  border-radius: 8px;
  background-color: #f5f5f5;
  margin: 0;
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 12px;
  text-align: left;
  color: #979797;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  cursor: default;
}

.workshop-hover:hover {
  background-color: rgba(2, 119, 189, 0.1);
  cursor: pointer;
}

.module-selected {
  background-color: rgba(2, 119, 189, 0.2);
}

.workshop-description {
  margin: 8px 0 0;
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 12px;
  text-align: left;
  color: #979797;
  white-space: pre-wrap;
}

.workshop-icon {
  margin-right: 12px;
  width: 20px;
  height: 20px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}

.selected {
  transform: rotate(-45deg);
}

.indicator {
  text-align: end;
  padding-right: 32px;
}

.attendancy-color {
  font-family: 'Source Sans Pro', sans-serif;
  line-height: 2;
  font-weight: bold;
  position: relative;
}

.attending {
  font-size: 18px;
}

.limit {
  font-size: 12px;
}

.full,
.overlap {
  font-family: Raleway, sans-serif;
  font-weight: bold;
  text-align: center;
  color: #333;
}

.full {
  font-size: 18px;
}

.overlap {
  font-size: 12px;
}

.standalone-overlap {
  display: block;
  width: 69px;
}

@keyframes show-check {
  0% {
    opacity: 0;
    transform: scale(0.5);
  }
  30% {
    opacity: 1;
    transform: scale(1);
  }
  70% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(0.5);
  }
}

.check {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  font-size: 44px;
  border-radius: 50%;
  background: #fff;
  opacity: 0;
  transform: scale(0.5);
}

.module-selected .check {
  animation: show-check 1.5s cubic-bezier(0.25, 0.8, 0.5, 1);
}

.disabled .workshop-icon {
  opacity: 0;
}

.disabled .workshop-title span,
.disabled span > span {
  color: #333333;
}
</style>
